// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ctm-tool-section{padding:24px 0 8px}.ctm-tool-section__head{margin-bottom:24px}.ctm-tool-section__title{font-size:16px;font-weight:600;color:#1e1f21;margin:0 0 6px}.ctm-tool-section__desc{font-size:13px;color:#6b7280;margin:0;max-width:600px;line-height:1.6}.ctm-tool-section__body{max-width:680px}", ""]);
// Exports
module.exports = exports;
